import isObject from 'lodash/isObject';
import sortBy from 'lodash/sortBy';

import isEmptyFilterValue from './isEmptyFilterValue';

const getValueString = (value) => {
  if (Array.isArray(value)) {
    return sortBy(value)
      .map((item) => getValueString(item))
      .toString();
  }

  if (isObject(value)) {
    return sortBy(Object.keys(value))
      .reduce((acc, key) => {
        const item = getValueString(value[key]);
        return item ? [...acc, `${key}:${item}`] : acc;
      }, [])
      .toString();
  }

  return !isEmptyFilterValue(value) ? String(value) : '';
};

const isEqualFilterValues = (value, other) =>
  getValueString(value) === getValueString(other);

export default isEqualFilterValues;
